module.exports = __webpack_public_path__ + "static/media/logo_diva.bb1c4ff5.svg";